---
meta:
  - title: Qué es un agente - IUSPRO Docs
  - description: Entienda qué es un agente, para qué sirve y en qué tipo de trabajo jurídico le puede ahorrar tiempo.
---

# Qué es un agente

Un **agente** sirve para dejar preparado un trabajo que usted hace seguido, para no tener que volver a explicárselo a la
plataforma cada vez.

Piense en algo así:

- usted aporta los hechos y documentos del asunto
- el sistema estudia el caso
- luego ordena las ideas
- después redacta, revisa o traduce, según lo que usted haya definido

Al final, usted recibe un resultado más trabajado que una simple respuesta suelta.

## ¿Para qué sirve?

Sirve para tareas jurídicas que se repiten mucho en la práctica diaria.

Por ejemplo:

- analizar hechos y convertirlos en una línea argumentativa
- estudiar un asunto y dejar un primer borrador de escrito
- preparar un documento y luego pasarlo por una revisión interna
- producir una versión final y después traducirla

## Un ejemplo real

Imagine que usted responde prevenciones registrales con frecuencia.

Normalmente su trabajo se parece a esto:

1. leer la prevención y los documentos de soporte
2. entender cuál es el problema
3. ordenar la respuesta
4. redactar el escrito
5. revisar si quedó bien enfocado

Ese modo de trabajar es precisamente lo que puede dejar armado en un agente.

## Qué gana al usarlo

- **Ahorra tiempo**: no repite las mismas instrucciones largas
- **Mantiene criterio**: el trabajo sigue la misma lógica en casos parecidos
- **Ordena mejor el proceso**: primero estudia, luego redacta, luego revisa
- **Se reutiliza**: el mismo agente puede servir para muchos asuntos del mismo tipo

## Qué no es un agente

Un agente no es un chat libre como Auri.

Tampoco es una automatización complicada.

Es algo mucho más fácil de entender:

- usted define un tipo de trabajo
- el sistema lo hace en el orden que usted decidió
- usted revisa el resultado

## Qué partes tiene

Todo agente tiene:

- una primera parte donde usted aporta la información del asunto
- una o varias etapas de trabajo después

Esas etapas pueden servir para:

- analizar jurídicamente
- buscar apoyo en la web
- ordenar ideas
- redactar un documento
- revisar un borrador
- traducir una versión final

## Qué pasa cuando lo ejecuta

Cuando ejecuta un agente:

- completa la información inicial
- puede adjuntar expediente, cliente o redacciones existentes
- el sistema hace el trabajo en segundo plano
- usted puede revisar cada parte del resultado

## Resultado final

El resultado final depende de cómo termine el agente:

- si termina en texto, verá una respuesta final lista para leer
- si termina en **Redactor**, el resultado queda en un documento real
- si no termina en Redactor, luego puede seguir trabajando ese resultado en Auri

## Siguiente lectura

- Lea [cuándo conviene usar un agente](/guias/agentes-cuando-usarlo)
- Aprenda [cómo crear un agente](/guias/agentes-como-crear)
